import React from "react";
import { Clock, Target, ShieldCheck, TrendingUp } from "lucide-react";

const BENEFITS = [
  {
    icon: Clock,
    title: "Save your time",
    text: "You stay focused on creating. I take the product build off your plate from start to finish.",
  },
  {
    icon: Target,
    title: "Clear positioning",
    text: "An offer that fits your audience &mdash; not a generic course template forced onto your brand.",
  },
  {
    icon: ShieldCheck,
    title: "No upfront risk",
    text: "Revenue split means I only win when you win. Aligned incentives from day one.",
  },
  {
    icon: TrendingUp,
    title: "Real revenue",
    text: "Turn the audience you already have into a recurring income stream you actually own.",
  },
];

export const WhyItMatters = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="border-b border-zinc-200/70 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="section-label">Why it matters</span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-zinc-900 tracking-tight leading-[1.05]">
              You already have the hardest part.
            </h2>
            <p className="mt-6 text-zinc-600 text-lg leading-relaxed max-w-md">
              Building an audience takes years. Most creators sit on that audience without a product to offer them. My job is to fix that &mdash; quickly, cleanly, and with skin in the game.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5 md:gap-6">
            {BENEFITS.map((b) => (
              <Benefit key={b.title} benefit={b} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const Benefit = ({ benefit }) => {
  const Icon = benefit.icon;
  return (
    <div
      data-testid={`benefit-${benefit.title.toLowerCase().replace(/\s+/g, '-')}`}
      className="rounded-2xl bg-white border border-zinc-200 p-7 hover:border-zinc-300 hover:shadow-md transition-all duration-300"
    >
      <div className="inline-flex items-center justify-center h-11 w-11 rounded-xl bg-blue-50 text-blue-700 mb-5">
        <Icon size={20} />
      </div>
      <h3 className="font-heading text-xl font-semibold text-zinc-900 tracking-tight">
        {benefit.title}
      </h3>
      <p
        className="mt-2 text-zinc-600 text-base leading-relaxed"
        dangerouslySetInnerHTML={{ __html: benefit.text }}
      />
    </div>
  );
};

export default WhyItMatters;
